// extracted by mini-css-extract-plugin
export var container = "_7c-0";
export var error = "_7c-9";
export var label = "_7c-5";
export var light = "_7c-6";
export var md = "_7c-3";
export var sm = "_7c-2";
export var thin = "_7c-8";
export var thinBold = "_7c-7";
export var vertical = "_7c-4";
export var xs = "_7c-1";